import React from "react";
import { getFileExt } from "../utils/utils";
import { fileIcons } from "../Icons";

const FileUploading = ({ files = [] }) => {
  return (
    <div className="bg-white fixed bottom-0 left-0 md:left-auto md:right-0 flex flex-col gap-4 items-center justify-center z-[2001] rounded-tl-[14px] rounded-tr-[14px] md:rounded-tr-none w-full md:w-fit p-4 border border-gray-300">
      <p
        className="text-base font-medium text-left text-[#232323] text-[0.9rem] w-full"
        //   style={{ color: sendButtonColor }}
      >
        Uploading {files?.length} files
      </p>
      {files.length > 0 && (
        <div className="flex flex-col w-full md:w-auto gap-2 overflow-auto max-h-[10rem] ">
          {files?.map((file) => {
            const ext = getFileExt(file.name);
            const Icon = fileIcons?.[ext];
            return (
              <div className="flex items-center gap-2 w-full md:w-auto">
                <span>
                  <Icon />
                </span>
                <span className="text-[#333333] truncate w-[80%] text-[0.9rem] font-normal">
                  {file.name}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FileUploading;
